let initial = {
  list: [],
  allBusiness: [],
  listBusinessByCategory: [],
  products: [],
  categories: []
};

function fairs(state = initial, action) {
  switch (action.type) {
    case 'UPDATE_LIST_BUSINESS_OF_FAIR':
      return Object.assign({}, state, {
        list: action.list
      })
    case 'REMOVE_BUSINESS_OF_FAIR':
      return Object.assign({}, state, {
        list: state.list.filter(item => item.id != action.businessId)
      })
    case 'UPDATE_LIST_PRODUCT_OF_FAIR':
      return Object.assign({}, state, {
        products: action.list
      })
    case 'UPDATE_CATEGORIES_OF_FAIR':
      return Object.assign({}, state, {
        categories: action.data
      })
    case 'UPDATE_LIST_ALL_BUSINESS_OF_FAIR':
      return Object.assign({}, state, {
        allBusiness: action.list
      })
    case 'UPDATE_LIST_BUSINESS_BY_CATEGORY_OF_FAIR':
      return Object.assign({}, state, {
        listBusinessByCategory: fetchBusinessList(state.allBusiness || [], action.listBusinessByCategory)
      })
    case 'ADD_BUSINESS_FAIR':
      let newListBusiness = [...state.allBusiness, {dntId: 'dnt_' + action.id}]
      return Object.assign({}, state, {
        allBusiness: newListBusiness,
        listBusinessByCategory: fetchBusinessList(newListBusiness || [], state.listBusinessByCategory)
      })
    case 'REMOVE_BUSINESS_FAIR':
      return Object.assign({}, state, {
        list: list.filter(item => item.id != action.id)
      })
    default:
      return state;
  }
}

function fetchBusinessList (allBusiness, listBusinessByCategory) {
  if (allBusiness.length === 0 || listBusinessByCategory.length === 0) {
    return listBusinessByCategory
  } else {
    let newListBusiness = [];
    listBusinessByCategory.map(item => {
      let findIndex = allBusiness.findIndex(itemList => itemList.dntId.substring(4, itemList.dntId.length) === item.id)
      if (findIndex !== -1) {
        if (allBusiness[findIndex].status === 0) {
          newListBusiness = [
            ...newListBusiness,
            {...item, awaiting: true}
          ]
        } else {
          newListBusiness = [
            ...newListBusiness,
            {...item, exist: true}
          ]
        }
      } else {
        newListBusiness.push(item)
      }
    })
    return newListBusiness
  }
}

export {fairs}



// WEBPACK FOOTER //
// ./reducers/fairs.js